import { render, staticRenderFns } from "./AddSubtitle.vue?vue&type=template&id=4c25b73e&scoped=true&"
import script from "./AddSubtitle.vue?vue&type=script&lang=js&"
export * from "./AddSubtitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c25b73e",
  null
  
)

export default component.exports